module.exports = __webpack_public_path__ + "static/media/newsletter-december-2023-6.6541641c.jpg";